export const environment = {
  production: true,
  ImpataAppAPIRoot: "https://lmsapi.impata.com/",

  //ImpataAppAPIRoot : "https://localhost:44326/",

  userTokenStore: "utkn",
  timezoneapikey: "0d933aa277de4030ae2203539fdf47c4",
  schConfig: "schcfg",
  googleClientId: "781136971353-sq8njd14nkgom1c7jctt9jfioo10a6t0.apps.googleusercontent.com",
  ImpataAppDomainUrl: "https://impata.com",
  stripePK: "pk_live_51T8zbaDbYOCv27ZH9bnDCU5kAHbrxVBAgeKRYKUAbmjAOEwzHmqRd0hz6lQ8rM4gnyjYs8ld4ioMQdoBcewyO5Ad00Oj8AzrPU"
};
